const states = [
  { abbr: 'All', name: 'All' },
  { abbr: 'AL', name: 'Alabama' },
  { abbr: 'AK', name: 'Alaska' },
  { abbr: 'AZ', name: 'Arizona' },
  { abbr: 'AR', name: 'Arkansas' },
  { abbr: 'CA', name: 'California' },
  { abbr: 'CO', name: 'Colorado' },
  { abbr: 'CT', name: 'Connecticut' },
  { abbr: 'DC', name: 'District of Columbia' },
  { abbr: 'DE', name: 'Delaware' },
  { abbr: 'FL', name: 'Florida' },
  { abbr: 'GA', name: 'Georgia' },
  { abbr: 'HI', name: 'Hawaii' },
  { abbr: 'ID', name: 'Idaho' },
  { abbr: 'IL', name: 'Illinois' },
  { abbr: 'IN', name: 'Indiana' },
  { abbr: 'IA', name: 'Iowa' },
  { abbr: 'KS', name: 'Kansas' },
  { abbr: 'KY', name: 'Kentucky' },
  { abbr: 'LA', name: 'Louisiana' },
  { abbr: 'ME', name: 'Maine' },
  { abbr: 'MD', name: 'Maryland' },
  { abbr: 'MA', name: 'Massachusetts' },
  { abbr: 'MI', name: 'Michigan' },
  { abbr: 'MN', name: 'Minnesota' },
  { abbr: 'MS', name: 'Mississippi' },
  { abbr: 'MO', name: 'Missouri' },
  { abbr: 'MT', name: 'Montana' },
  { abbr: 'NE', name: 'Nebraska' },
  { abbr: 'NV', name: 'Nevada' },
  { abbr: 'NH', name: 'New Hampshire' },
  { abbr: 'NJ', name: 'New Jersey' },
  { abbr: 'NM', name: 'New Mexico' },
  { abbr: 'NY', name: 'New York' },
  { abbr: 'NC', name: 'North Carolina' },
  { abbr: 'ND', name: 'North Dakota' },
  { abbr: 'OH', name: 'Ohio' },
  { abbr: 'OK', name: 'Oklahoma' },
  { abbr: 'OR', name: 'Oregon' },
  { abbr: 'PA', name: 'Pennsylvania' },
  { abbr: 'PR', name: 'Puerto Rico' },
  { abbr: 'RI', name: 'Rhode Island' },
  { abbr: 'SC', name: 'South Carolina' },
  { abbr: 'SD', name: 'South Dakota' },
  { abbr: 'TN', name: 'Tennessee' },
  { abbr: 'TX', name: 'Texas' },
  { abbr: 'UT', name: 'Utah' },
  { abbr: 'VT', name: 'Vermont' },
  { abbr: 'VA', name: 'Virginia' },
  { abbr: 'WA', name: 'Washington' },
  { abbr: 'WV', name: 'West Virginia' },
  { abbr: 'WI', name: 'Wisconsin' },
  { abbr: 'WY', name: 'Wyoming' },
];

export function useStates() {
  return states;
}

export function useStatesOptions() {
  return states.map((state) => {
    return {
      value: state.abbr,
      display: state.name,
    };
  });
}

const sortedStates = states.slice().sort((a, b) => {
  if (a.abbr === 'All') return -1;
  if (b.abbr === 'All') return 1;
  return a.abbr.localeCompare(b.abbr);
});

export function useStatesOptionsAbbr() {
  return sortedStates.map((state) => {
    return {
      value: state.abbr === 'All' ? '' : state.abbr,
      display: state.abbr,
    };
  });
}

export function getAbbrStatesAsArray() {
  return sortedStates.map((state) => state.abbr);
}

/**
 * Gets the full name of a state
 * @param stateName Two letter state abbreviation or full state name.
 * @returns Full state name.
 * @example
 * import { lookupStateName } from '@/utils/states';
 *
 * // state = 'New York';
 * const state = lookupStateName('NY');
 * @example
 * // state = 'NY';
 * const state = lookupStateName('New york');
 */
export function lookupStateName(stateName: string | null | undefined) {
  if (stateName === null || stateName === undefined) return '';
  stateName = stateName.toLocaleLowerCase();
  const stateObject = states.find(
    (state) =>
      state.abbr.toLocaleLowerCase() === stateName ||
      state.name.toLocaleLowerCase() === stateName
  );
  if (stateObject) {
    if (stateName.length > 2) {
      return stateObject.abbr;
    }
    return stateObject.name;
  }
}

export function isValidState(option: string | undefined): boolean {
  const statesArr = getAbbrStatesAsArray();

  return (
    statesArr &&
    statesArr.some((opt) => {
      return opt === option;
    })
  );
}
